import { useState, useEffect, useCallback } from 'react'
import { API_URL } from '../config/api'

export const useCorreccionesPropuestas = (empleado) => {
  const [propuestasPendientes, setPropuestasPendientes] = useState([])
  const [loading, setLoading] = useState(true)

  const cargarPropuestas = useCallback(async () => {
    if (!empleado || empleado.rol === 'super_admin' || empleado.is_admin) {
      setLoading(false)
      return
    }

    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${API_URL}/correcciones/mis-propuestas?estado=pendiente`, {
        headers: { 'Authorization': `Bearer ${token}` }
      })
      if (response.ok) {
        const data = await response.json()
        setPropuestasPendientes(data)
      }
    } catch (error) {
      console.error('Error cargando propuestas de corrección:', error)
    } finally {
      setLoading(false)
    }
  }, [empleado])

  useEffect(() => {
    cargarPropuestas()
  }, [cargarPropuestas])

  return { propuestasPendientes, loading, recargar: cargarPropuestas }
}
